// extracted by mini-css-extract-plugin
module.exports = {"siteLogo":"site-logo-module--siteLogo--1vthy"};